module.exports = __webpack_public_path__ + "static/media/logo.37f9400b.png";